import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const LOCATION_EVENT_NAMES = {
  CLICK_STREET_VIEW: 'click_street_view_button',
  CLICK_ESTIMATED_FLOOR_LEVEL: 'open_estimated_floor_level',
};

export const trackClickStreetView = (
  irpVersion,
  payloadID,
  requestID,
  portalType,
) => {
  gspx.trackEvent({
    name: LOCATION_EVENT_NAMES.CLICK_STREET_VIEW,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Jurisdiction View',
      legacy_name: 'Click Street View button (ESRI MAP)',
      Category: 'Jurisdiction View',
      'Launched date': new Date(),
      irpVersion,
      portalType,
    },
    entities: {
      payload_id: payloadID,
      request_id: requestID,
    },
  });
};

export const trackClickEstimatedFloorLevel = (
  irpVersion,
  payloadID,
  requestID,
  portalType,
) => {
  gspx.trackEvent({
    name: LOCATION_EVENT_NAMES.CLICK_ESTIMATED_FLOOR_LEVEL,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Jurisdiction View',
      legacy_name: 'Open Estimated Floor Level',
      Category: 'Jurisdiction View',
      'Launched date': new Date(),
      irpVersion,
      portalType,
    },
    entities: {
      payload_id: payloadID,
      request_id: requestID,
    },
  });
};
